/* Write here our cusom javascript */
// For slick slider
$(document).ready(function(){
  $('.sliding-content').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    speed: 300,
    arrows: true,
    //autoplay: true,
    //autoplaySpeed: 2000,
  });
});